<!-- subsidy-distribution.component.html -->
<div class="card dashboardTable">
  <!-- First Table (Non-Tank Activities) -->
  <div class="table-container scrollable-table card">
    <p-table [value]="dataFormatType2_nonTank" [loading]="loadingTable2_nonTank" [rowGroupMode]="'rowspan'"
      [groupRows]="true" [sortField]="'Activities'" [sortOrder]="1">

      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <!-- Left side -->
          <div class="col-8">
            <p class="m-0 main-heading">Financial Progress under PDMC for MICADA Portal 2.0( MI)</p>
            <p class="sub-heading">Table 1</p>
          </div>
          <!-- Middle section for buttons -->
          <div class="col-0 d-flex  justify-content-between">
          </div>

          <!-- Right side for search -->
          <div class="col-4 d-flex align-items-center justify-content-end">
            <!-- <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="appVerificationTable.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
                </span> -->
            <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
              class="p-button-help mx-1"></button>
            <!-- <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button> -->
            <p-menu #menu [popup]="true" [model]="tableItems1"></p-menu>
          </div>
        </div>
      </ng-template>

      <!-- Define Grouped Columns -->
      <ng-template pTemplate="header">
        <tr>
          <th rowspan="2">Activities</th>
          <th rowspan="2">F.Y.</th>
          <th rowspan="2">No of Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
        </tr>
        <tr>
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr>
          <!-- Activities Column with Rowspan -->
          <td *ngIf="shouldShowActivities2_nonTank(rowIndex)" [rowSpan]="rowSpan2_nonTank[rowData.Activities]"
            class="activities-cell">
            {{ rowData.Activities }}
          </td>
          <td>{{ rowData['F.Y.'] }}</td>
          <!-- <td>{{ rowData['No. of Lots'] || '' }}</td> -->
          <td (click)="onClickTable1(rowData)" class="clickable-text">{{ rowData['No. of Lots'] || '' }}</td>
          <td (click)="getDrillDownData(rowData, '2', 'success', rowData['Success Applications'])" class="clickable-text">{{ rowData['Success Applications'] }}</td>
          <td>{{ rowData['Success Amount'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '2', 'error', rowData['Error Applications'])" class="clickable-text">{{ rowData['Error Applications'] }}</td>
          <td>{{ rowData['Error Amount'] | indianDecimal }}</td>
        </tr>
      </ng-template>

      <!-- Footer for Grand Totals -->
      <ng-template pTemplate="footer">
        <tr class="grand-total-row">
          <td colspan="3" style="text-align: right; font-weight: bold;">Grand Total:</td>
          <td>{{ grandTotalSuccessApplications2_nonTank }}</td>
          <td>{{ grandTotalSuccessAmount2_nonTank | indianDecimal }}</td>
          <td>{{ grandTotalErrorApplications2_nonTank }}</td>
            <td>{{ grandTotalErrorAmount2_nonTank | indianDecimal }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Loader for Non-Tank Table -->
    <p-progressSpinner *ngIf="loadingTable2_nonTank" styleClass="custom-spinner"></p-progressSpinner>
  </div>

  <!-- Second Table (Tank Activities) -->
  <div class="table-container scrollable-table card">
    <p-table [value]="dataFormatType2_tank" [loading]="loadingTable2_tank" [rowGroupMode]="'rowspan'" [groupRows]="true"
      [sortField]="'Activities'" [sortOrder]="1">

      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <!-- Left side -->
          <div class="col-8">
            <p class="m-0 main-heading">Financial Progress under PDMC for MICADA Portal 2.0 (Tank)</p>
            <p class="sub-heading">Table 2</p>
          </div>
          <!-- Middle section for buttons -->
          <div class="col-0 d-flex  justify-content-between">
          </div>

          <!-- Right side for search -->
          <div class="col-4 d-flex align-items-center justify-content-end">
            <!-- <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="appVerificationTable.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
                </span> -->
            <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
              class="p-button-help mx-1"></button>
            <!-- <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button> -->
            <p-menu #menu [popup]="true" [model]="tableItems2"></p-menu>
          </div>
        </div>
      </ng-template>

      <!-- Define Grouped Columns -->
      <ng-template pTemplate="header">
        <tr>
          <th rowspan="2">Activities</th>
          <th rowspan="2">F.Y.</th>
          <th rowspan="2">No of Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
        </tr>
        <tr>
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr>
          <!-- Activities Column with Rowspan -->
          <td *ngIf="shouldShowActivities2_tank(rowIndex)" [rowSpan]="rowSpan2_tank[rowData.Activities]"
            class="activities-cell">
            {{ rowData.Activities }}
          </td>
          <td>{{ rowData['F.Y.'] }}</td>
          <!-- <td>{{ rowData['No. of Lots'] || '' }}</td> -->
          <td (click)="onClickTable2(rowData)" class="clickable-text">{{ rowData['No. of Lots'] || '' }}</td>
          <td (click)="getDrillDownData(rowData, '2', 'success', rowData['Success Applications'])" class="clickable-text">{{ rowData['Success Applications'] }}</td>
          <td>{{ rowData['Success Amount'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '2', 'error', rowData['Error Applications'])" class="rowData['Error Applications'] > 0 ? clickable-text : '' ">{{ rowData['Error Applications'] }}</td>
          <td>{{ rowData['Error Amount'] | indianDecimal }}</td>
        </tr>
      </ng-template>

      <!-- Footer for Grand Totals -->
      <ng-template pTemplate="footer">
        <tr class="grand-total-row">
          <td colspan="3" style="text-align: right; font-weight: bold;">Grand Total:</td>
          <td>{{ grandTotalSuccessApplications2_tank }}</td>
          <td>{{ grandTotalSuccessAmount2_tank | indianDecimal }}</td>
          <td>{{ grandTotalErrorApplications2_tank }}</td>
          <td>{{ grandTotalErrorAmount2_tank | indianDecimal }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Loader for Tank Table -->
    <p-progressSpinner *ngIf="loadingTable2_tank" styleClass="custom-spinner"></p-progressSpinner>
  </div>
  <!-- Third Table (FormatType=3) -->
  <div class="table-container scrollable-table card">
    <p-table [value]="dataFormatType3" [loading]="loadingTable3" responsiveLayout="stack" [breakpoint]="'960px'"
      [tableStyle]="{'min-width': '50rem'}">

      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <!-- Left side -->
          <div class="col-8">
            <p class="m-0 main-heading">Gist of Expenditure in PDMC for installation of MI System & Construction of OFWT</p>
            <p class="sub-heading">Table 3</p>
          </div>
          <!-- Middle section for buttons -->
          <div class="col-0 d-flex  justify-content-between">
          </div>

          <!-- Right side for search -->
          <div class="col-4 d-flex align-items-center justify-content-end">
            <!-- <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="appVerificationTable.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
                </span> -->
            <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
              class="p-button-help mx-1"></button>
            <!-- <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button> -->
            <p-menu #menu [popup]="true" [model]="tableItems3"></p-menu>
          </div>
        </div>
      </ng-template>

      <!-- Define Header -->
      <ng-template pTemplate="header">
        <tr>
          <th rowspan="2">Activities</th>
          <!-- F.Y. Headers -->
          <th colspan="2">F.Y. -</th>
          <th colspan="2">F.Y. 2022-23</th>
          <th colspan="2">F.Y. 2023-24</th>
          <th colspan="2">F.Y. 2024-25</th>
          <th colspan="2">Grand Total</th>
        </tr>
        <tr>
          <!-- F.Y. - Columns -->
          <th>Applications</th>
          <th>Amount</th>
          <!-- F.Y. 2022-23 Columns -->
          <th>Applications</th>
          <th>Amount</th>
          <!-- F.Y. 2023-24 Columns -->
          <th>Applications</th>
          <th>Amount</th>
          <!-- F.Y. 2024-25 Columns -->
          <th>Applications</th>
          <th>Amount</th>
          <!-- Grand Total Columns -->
          <th>Applications</th>
          <th>Amount</th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td>{{ rowData.Activities }}</td>
          <td (click)="getDrillDownData(rowData, '3', 'success', rowData['Applications -'], '-')" class="clickable-text">{{ rowData['Applications -'] }}</td>
          <td>{{ rowData['Amount -'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '3', 'success', rowData['Applications 2022-23'], '2022-23')" class="clickable-text">{{ rowData['Applications 2022-23'] }}</td>
          <td>{{ rowData['Amount 2022-23'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '3', 'success', rowData['Applications 2023-24'], '2023-24')" class="clickable-text">{{ rowData['Applications 2023-24'] }}</td>
          <td>{{ rowData['Amount 2023-24'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '3', 'success', rowData['Applications 2024-25'], '2024-25')" class="clickable-text">{{ rowData['Applications 2024-25'] }}</td>
          <td>{{ rowData['Amount 2024-25'] | indianDecimal }}</td>
          <td>{{ rowData['Total Applications'] }}</td>
          <td>{{ rowData['Total Amount'] | indianDecimal }}</td>
        </tr>
      </ng-template>

      <!-- Footer for Grand Totals -->
      <ng-template pTemplate="footer">
        <tr class="grand-total-row">
          <td style="text-align: right; font-weight: bold;">Grand Total:</td>
          <td>{{ grandTotals3['Applications -'] }}</td>
          <td>{{ grandTotals3['Amount -'] | indianDecimal }}</td>
          <td>{{ grandTotals3['Applications 2022-23'] }}</td>
          <td>{{ grandTotals3['Amount 2022-23'] | indianDecimal }}</td>
          <td>{{ grandTotals3['Applications 2023-24'] }}</td>
          <td>{{ grandTotals3['Amount 2023-24'] | indianDecimal }}</td>
          <td>{{ grandTotals3['Applications 2024-25'] }}</td>
          <td>{{ grandTotals3['Amount 2024-25'] | indianDecimal }}</td>
          <td>{{ grandTotals3['Total Applications'] }}</td>
          <td>{{ grandTotals3['Total Amount'] | indianDecimal }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Loader for Third Table -->
    <p-progressSpinner *ngIf="loadingTable3" styleClass="custom-spinner"></p-progressSpinner>
  </div>

  <!-- 4th Table (FormatType=4) -->
  <div class="table-container scrollable-table card">
    <p-table [value]="dataFormatType4" [loading]="loadingTable4" [rowGroupMode]="'rowspan'" [groupRows]="true"
      [sortField]="'Activities'" [sortOrder]="1">
  
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <!-- Left side -->
          <div class="col-8">
            <p class="m-0 main-heading">Gist of FTV: Year wise actual payment details to vendors as Farmer share</p>
            <p class="sub-heading">Table 4(a)</p>
          </div>
          <!-- Middle section for buttons -->
          <div class="col-0 d-flex  justify-content-between">
          </div>

          <!-- Right side for search -->
          <div class="col-4 d-flex align-items-center justify-content-end">
            <!-- <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="appVerificationTable.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
                </span> -->
            <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
              class="p-button-help mx-1"></button>
            <!-- <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button> -->
            <p-menu #menu [popup]="true" [model]="tableItems4"></p-menu>
          </div>
        </div>
      </ng-template>

      <!-- Define Grouped Columns -->
      <ng-template pTemplate="header">
        <tr>
          <th rowspan="2">Activities</th>
          <th rowspan="2">F.Y.</th>
          <th rowspan="2">No. of Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
        </tr>
        <tr>
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr>
          <!-- Activities Column with Rowspan -->
          <td *ngIf="shouldShowActivities4(rowIndex)" [rowSpan]="rowSpan4[rowData.Activities]" class="activities-cell">
            {{ rowData.Activities }}
          </td>
          <td>{{ rowData['F.Y.'] }}</td>
          <!-- <td>{{ rowData['No. of Lots'] }}</td> -->
          <td (click)="onClickTable4(rowData)" class="clickable-text">{{ rowData['No. of Lots'] || '' }}</td>
          <td (click)="getDrillDownData(rowData, '4', 'success', rowData['Success Applications'])" class="clickable-text">{{ rowData['Success Applications'] }}</td>
          <td>{{ rowData['Success Amount'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '4', 'error', rowData['Error Applications'])" class="clickable-text">{{ rowData['Error Applications'] }}</td>
          <td>{{ rowData['Error Amount'] | indianDecimal }}</td>
        </tr>
      </ng-template>

      <!-- Footer for Grand Totals -->
      <ng-template pTemplate="footer">
        <tr class="grand-total-row">
          <td colspan="3" style="text-align: right; font-weight: bold;">Grand Total:</td>
          <td>{{ grandTotalSuccessApplications4 }}</td>
          <td>{{ grandTotalSuccessAmount4 | indianDecimal }}</td>
          <td>{{ grandTotalErrorApplications4 }}</td>
          <td>{{ grandTotalErrorAmount4 | indianDecimal }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Loader for Second Table -->
    <p-progressSpinner *ngIf="loadingTable4" styleClass="custom-spinner"></p-progressSpinner>
  </div>

  <!-- 4th (b) Table (FormatType=4b) -->

  <div class="table-container scrollable-table card">

    <!-- <p class="sub-heading">Table 4b</p> -->

    <p-table [value]="dataFormatType4b" [loading]="loadingTable6" [rowGroupMode]="'rowspan'" [groupRows]="true"
      [sortField]="'Activities'" [sortOrder]="1">

      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-end">
          <!-- Left side -->
          <div class="col-8">
            <p class="m-0 main-heading">System Wise Bifurcation of FTV</p>
            <p class="sub-heading">Table 4 (b)</p>
          </div>
          <!-- Middle section for buttons -->
          <div class="col-0 d-flex  justify-content-between">
          </div>

          <!-- Right side for search -->
          <div class="col-4 d-flex align-items-center justify-content-end">
            <!-- <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="appVerificationTable.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
                </span> -->
            <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
              class="p-button-help mx-1"></button>
            <!-- <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button> -->
            <p-menu #menu [popup]="true" [model]="tableItems4b"></p-menu>
          </div>
        </div>
      </ng-template>

      <!-- Header Rows -->
      <ng-template pTemplate="header">
        <!-- First Header Row -->
        <tr>
          <th rowspan="3">Activities</th>
          <th rowspan="3">Type</th> <!-- Type is Program_Name -->
          <!-- F.Y. Headers -->
          <th colspan="5" style="text-align: center;">F.Y. -</th>
          <th colspan="5" style="text-align: center;">F.Y. 2022-23</th>
          <th colspan="5" style="text-align: center;">F.Y. 2023-24</th>
          <th colspan="5" style="text-align: center;">F.Y. 2024-25</th>
        </tr>
        <!-- Second Header Row -->
        <tr>
          <!-- For F.Y. - -->
          <th rowspan="2">Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
          <!-- For F.Y. 2022-23 -->
          <th rowspan="2">Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
          <!-- For F.Y. 2023-24 -->
          <th rowspan="2">Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
          <!-- For F.Y. 2024-25 -->
          <th rowspan="2">Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
        </tr>
        <!-- Third Header Row -->
        <tr>
          <!-- F.Y. - -->
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
          <!-- F.Y. 2022-23 -->
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
          <!-- F.Y. 2023-24 -->
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
          <!-- F.Y. 2024-25 -->
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr>
          <!-- Activities Column with Rowspan -->
          <td *ngIf="shouldShowActivities4b(rowIndex)" [rowSpan]="rowSpan4b[rowData.Activities]" class="activities-cell">
            {{ rowData.Activities }}
          </td>
          <td>{{ rowData.Type }}</td>
          <!-- F.Y. - Data -->
          <td>{{ rowData['Lots -'] }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'success', rowData['Success Applications -'], '-')" class="clickable-text">{{ rowData['Success Applications -'] }}</td>
          <td>{{ rowData['Success Amount -'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'error', rowData['Error Applications -'], '-')" class="clickable-text">{{ rowData['Error Applications -'] }}</td>
          <td>{{ rowData['Error Amount -'] | indianDecimal }}</td>
          <!-- F.Y. 2022-23 Data -->
          <td>{{ rowData['Lots 2022-23'] }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'success', rowData['Success Applications 2022-23'], '2022-23')" class="clickable-text">{{ rowData['Success Applications 2022-23'] }}</td>
          <td>{{ rowData['Success Amount 2022-23'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'error', rowData['Error Applications 2022-23'], '2022-23')" class="clickable-text">{{ rowData['Error Applications 2022-23'] }}</td>
          <td>{{ rowData['Error Amount 2022-23'] | indianDecimal }}</td>
          <!-- F.Y. 2023-24 Data -->
          <td>{{ rowData['Lots 2023-24'] }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'success', rowData['Success Applications 2023-24'], '2023-24')" class="clickable-text">{{ rowData['Success Applications 2023-24'] }}</td>
          <td>{{ rowData['Success Amount 2023-24'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'error', rowData['Error Applications 2023-24'], '2023-24')" class="clickable-text">{{ rowData['Error Applications 2023-24'] }}</td>
          <td>{{ rowData['Error Amount 2023-24'] | indianDecimal }}</td>
          <!-- F.Y. 2024-25 Data -->
          <td>{{ rowData['Lots 2024-25'] }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'success', rowData['Success Applications 2024-25'], '2024-25')" class="clickable-text">{{ rowData['Success Applications 2024-25'] }}</td>
          <td>{{ rowData['Success Amount 2024-25'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'error', rowData['Error Applications 2024-25'], '2024-25')" class="clickable-text">{{ rowData['Error Applications 2024-25'] }}</td>
          <td>{{ rowData['Error Amount 2024-25'] | indianDecimal }}</td>
        </tr>
      </ng-template>

      <!-- Footer for Grand Totals -->
      <ng-template pTemplate="footer">
        <tr class="grand-total-row">
          <td colspan="2" style="text-align: right; font-weight: bold;">Grand Total:</td>
          <!-- F.Y. - Totals -->
          <td>{{ grandTotals4b['Lots -'] }}</td>
          <td>{{ grandTotals4b['Success Applications -'] }}</td>
          <td>{{ grandTotals4b['Success Amount -'] | indianDecimal }}</td>
          <td>{{ grandTotals4b['Error Applications -'] }}</td>
          <td>{{ grandTotals4b['Error Amount -'] | indianDecimal }}</td>
          <!-- F.Y. 2022-23 Totals -->
          <td>{{ grandTotals4b['Lots 2022-23'] }}</td>
          <td>{{ grandTotals4b['Success Applications 2022-23'] }}</td>
          <td>{{ grandTotals4b['Success Amount 2022-23'] | indianDecimal }}</td>
          <td>{{ grandTotals4b['Error Applications 2022-23'] }}</td>
          <td>{{ grandTotals4b['Error Amount 2022-23'] | indianDecimal }}</td>
          <!-- F.Y. 2023-24 Totals -->
          <td>{{ grandTotals4b['Lots 2023-24'] }}</td>
          <td>{{ grandTotals4b['Success Applications 2023-24'] }}</td>
          <td>{{ grandTotals4b['Success Amount 2023-24'] | indianDecimal }}</td>
          <td>{{ grandTotals4b['Error Applications 2023-24'] }}</td>
          <td>{{ grandTotals4b['Error Amount 2023-24'] | indianDecimal }}</td>
          <!-- F.Y. 2024-25 Totals -->
          <td>{{ grandTotals4b['Lots 2024-25'] }}</td>
          <td>{{ grandTotals4b['Success Applications 2024-25'] }}</td>
          <td>{{ grandTotals4b['Success Amount 2024-25'] | indianDecimal }}</td>
          <td>{{ grandTotals4b['Error Applications 2024-25'] }}</td>
          <td>{{ grandTotals4b['Error Amount 2024-25'] | indianDecimal }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Loader for Fourth Table -->
    <p-progressSpinner *ngIf="loadingTable6" styleClass="custom-spinner"></p-progressSpinner>
  </div>

  
  <!-- 5th Table (FormatType=5) -->

  <div class="table-container scrollable-table card">

    <!-- <p class="sub-heading">Table 6</p> -->

    <p-table [value]="dataFormatType6" [loading]="loadingTable6" [rowGroupMode]="'rowspan'" [groupRows]="true"
      [sortField]="'Activities'" [sortOrder]="1">

      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-end">
          <!-- Left side -->
          <div class="col-8">
            <!-- <p class="m-0 main-heading">Gist of Expenditure in PDMC for installation of MI System & Construction of OFWT</p> -->
            <p class="sub-heading">Table 5</p>
          </div>
          <!-- Middle section for buttons -->
          <div class="col-0 d-flex  justify-content-between">
          </div>

          <!-- Right side for search -->
          <div class="col-4 d-flex align-items-center justify-content-end">
            <!-- <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="appVerificationTable.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
                </span> -->
            <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
              class="p-button-help mx-1"></button>
            <!-- <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button> -->
            <p-menu #menu [popup]="true" [model]="tableItems5"></p-menu>
          </div>
        </div>
      </ng-template>

      <!-- Header Rows -->
      <ng-template pTemplate="header">
        <!-- First Header Row -->
        <tr>
          <th rowspan="3">Activities</th>
          <th rowspan="3">Type</th> <!-- Type is Program_Name -->
          <!-- F.Y. Headers -->
          <th colspan="5" style="text-align: center;">F.Y. -</th>
          <th colspan="5" style="text-align: center;">F.Y. 2022-23</th>
          <th colspan="5" style="text-align: center;">F.Y. 2023-24</th>
          <th colspan="5" style="text-align: center;">F.Y. 2024-25</th>
        </tr>
        <!-- Second Header Row -->
        <tr>
          <!-- For F.Y. - -->
          <th rowspan="2">Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
          <!-- For F.Y. 2022-23 -->
          <th rowspan="2">Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
          <!-- For F.Y. 2023-24 -->
          <th rowspan="2">Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
          <!-- For F.Y. 2024-25 -->
          <th rowspan="2">Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
        </tr>
        <!-- Third Header Row -->
        <tr>
          <!-- F.Y. - -->
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
          <!-- F.Y. 2022-23 -->
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
          <!-- F.Y. 2023-24 -->
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
          <!-- F.Y. 2024-25 -->
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr>
          <!-- Activities Column with Rowspan -->
          <td *ngIf="shouldShowActivities6(rowIndex)" [rowSpan]="rowSpan6[rowData.Activities]" class="activities-cell">
            {{ rowData.Activities }}
          </td>
          <td>{{ rowData.Type }}</td>
          <!-- F.Y. - Data -->
          <td>{{ rowData['Lots -'] }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'success', rowData['Success Applications -'], '-')" class="clickable-text">{{ rowData['Success Applications -'] }}</td>
          <td>{{ rowData['Success Amount -'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'error', rowData['Error Applications -'], '-')" class="clickable-text">{{ rowData['Error Applications -'] }}</td>
          <td>{{ rowData['Error Amount -'] | indianDecimal }}</td>
          <!-- F.Y. 2022-23 Data -->
          <td>{{ rowData['Lots 2022-23'] }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'success', rowData['Success Applications 2022-23'], '2022-23')" class="clickable-text">{{ rowData['Success Applications 2022-23'] }}</td>
          <td>{{ rowData['Success Amount 2022-23'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'error', rowData['Error Applications 2022-23'], '2022-23')" class="clickable-text">{{ rowData['Error Applications 2022-23'] }}</td>
          <td>{{ rowData['Error Amount 2022-23'] | indianDecimal }}</td>
          <!-- F.Y. 2023-24 Data -->
          <td>{{ rowData['Lots 2023-24'] }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'success', rowData['Success Applications 2023-24'], '2023-24')" class="clickable-text">{{ rowData['Success Applications 2023-24'] }}</td>
          <td>{{ rowData['Success Amount 2023-24'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'error', rowData['Error Applications 2023-24'], '2023-24')" class="clickable-text">{{ rowData['Error Applications 2023-24'] }}</td>
          <td>{{ rowData['Error Amount 2023-24'] | indianDecimal }}</td>
          <!-- F.Y. 2024-25 Data -->
          <td>{{ rowData['Lots 2024-25'] }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'success', rowData['Success Applications 2024-25'], '2024-25')" class="clickable-text">{{ rowData['Success Applications 2024-25'] }}</td>
          <td>{{ rowData['Success Amount 2024-25'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '6', 'error', rowData['Error Applications 2024-25'], '2024-25')" class="clickable-text">{{ rowData['Error Applications 2024-25'] }}</td>
          <td>{{ rowData['Error Amount 2024-25'] | indianDecimal }}</td>
        </tr>
      </ng-template>

      <!-- Footer for Grand Totals -->
      <ng-template pTemplate="footer">
        <tr class="grand-total-row">
          <td colspan="2" style="text-align: right; font-weight: bold;">Grand Total:</td>
          <!-- F.Y. - Totals -->
          <td>{{ grandTotals6['Lots -'] }}</td>
          <td>{{ grandTotals6['Success Applications -'] }}</td>
          <td>{{ grandTotals6['Success Amount -'] | indianDecimal }}</td>
          <td>{{ grandTotals6['Error Applications -'] }}</td>
          <td>{{ grandTotals6['Error Amount -'] | indianDecimal }}</td>
          <!-- F.Y. 2022-23 Totals -->
          <td>{{ grandTotals6['Lots 2022-23'] }}</td>
          <td>{{ grandTotals6['Success Applications 2022-23'] }}</td>
          <td>{{ grandTotals6['Success Amount 2022-23'] | indianDecimal }}</td>
          <td>{{ grandTotals6['Error Applications 2022-23'] }}</td>
          <td>{{ grandTotals6['Error Amount 2022-23'] | indianDecimal }}</td>
          <!-- F.Y. 2023-24 Totals -->
          <td>{{ grandTotals6['Lots 2023-24'] }}</td>
          <td>{{ grandTotals6['Success Applications 2023-24'] }}</td>
          <td>{{ grandTotals6['Success Amount 2023-24'] | indianDecimal }}</td>
          <td>{{ grandTotals6['Error Applications 2023-24'] }}</td>
          <td>{{ grandTotals6['Error Amount 2023-24'] | indianDecimal }}</td>
          <!-- F.Y. 2024-25 Totals -->
          <td>{{ grandTotals6['Lots 2024-25'] }}</td>
          <td>{{ grandTotals6['Success Applications 2024-25'] }}</td>
          <td>{{ grandTotals6['Success Amount 2024-25'] | indianDecimal }}</td>
          <td>{{ grandTotals6['Error Applications 2024-25'] }}</td>
          <td>{{ grandTotals6['Error Amount 2024-25'] | indianDecimal }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Loader for Fourth Table -->
    <p-progressSpinner *ngIf="loadingTable6" styleClass="custom-spinner"></p-progressSpinner>
  </div>

  <!-- 6th Table (FormatType=6) -->

  <div class="table-container scrollable-table card">
    <!-- <ng-template class="header_class" pTemplate="caption" style="background-color: none !important;"> -->
    <!-- <h2 style="position: sticky;">Table 5</h2> -->
    <!-- <p class="sub-heading">Table 5</p> -->
    <!-- </ng-template> -->
    <p-table [value]="dataFormatType5" [loading]="loadingTable5" [rowGroupMode]="'rowspan'" [groupRows]="true"
      [sortField]="'Activities'" [sortOrder]="1">

      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <!-- Left side -->
          <div class="col-8">
            <!-- <p class="m-0 main-heading">Gist of Expenditure in PDMC for installation of MI System & Construction of OFWT</p> -->
            <p class="sub-heading">Table 6</p>
          </div>
          <!-- Middle section for buttons -->
          <div class="col-0 d-flex  justify-content-between">
          </div>

          <!-- Right side for search -->
          <div class="col-4 d-flex align-items-center justify-content-end">
            <!-- <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="appVerificationTable.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
                </span> -->
            <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
              class="p-button-help mx-1"></button>
            <p-menu #menu [popup]="true" [model]="tableItems6"></p-menu>
            <!-- <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button> -->
          </div>
        </div>
      </ng-template>

      <!-- Header Rows -->
      <ng-template pTemplate="header">
        <!-- First Header Row -->
        <tr>
          <th rowspan="3">Activities</th>
          <th rowspan="3">Type</th>
          <!-- F.Y. Headers -->
          <th colspan="5" style="text-align: center;">F.Y. -</th>
          <th colspan="5" style="text-align: center;">F.Y. 2022-23</th>
          <th colspan="5" style="text-align: center;">F.Y. 2023-24</th>
          <th colspan="5" style="text-align: center;">F.Y. 2024-25</th>
        </tr>
        <!-- Second Header Row -->
        <tr>
          <!-- For F.Y. - -->
          <th rowspan="2">Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
          <!-- For F.Y. 2022-23 -->
          <th rowspan="2">Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
          <!-- For F.Y. 2023-24 -->
          <th rowspan="2">Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
          <!-- For F.Y. 2024-25 -->
          <th rowspan="2">Lots</th>
          <th colspan="2" style="text-align: center;">Success</th>
          <th colspan="2" style="text-align: center;">Error</th>
        </tr>
        <!-- Third Header Row -->
        <tr>
          <!-- F.Y. - -->
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
          <!-- F.Y. 2022-23 -->
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
          <!-- F.Y. 2023-24 -->
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
          <!-- F.Y. 2024-25 -->
          <th>Applications</th>
          <th>Amount</th>
          <th>Applications</th>
          <th>Amount</th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr>
          <!-- Activities Column with Rowspan -->
          <td *ngIf="shouldShowActivities5(rowIndex)" [rowSpan]="rowSpan5[rowData.Activities]" class="activities-cell">
            {{ rowData.Activities }}
          </td>
          <td>{{ rowData.Type }}</td>
          <!-- F.Y. - Data -->
          <td>{{ rowData['Lots -'] }}</td>
          <td (click)="getDrillDownData(rowData, '5', 'success', rowData['Success Applications -'], '-')" class="clickable-text">{{ rowData['Success Applications -'] }}</td>
          <td>{{ rowData['Success Amount -'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '5', 'error', rowData['Error Applications -'], '-')" class="clickable-text">{{ rowData['Error Applications -'] }}</td>
          <td>{{ rowData['Error Amount -'] | indianDecimal }}</td>
          <!-- F.Y. 2022-23 Data -->
          <td>{{ rowData['Lots 2022-23'] }}</td>
          <td (click)="getDrillDownData(rowData, '5', 'success', rowData['Success Applications 2022-23'], '2022-23')" class="clickable-text">{{ rowData['Success Applications 2022-23'] }}</td>
          <td>{{ rowData['Success Amount 2022-23'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '5', 'error', rowData['Error Applications 2022-23'], '2022-23')" class="clickable-text">{{ rowData['Error Applications 2022-23'] }}</td>
          <td>{{ rowData['Error Amount 2022-23'] | indianDecimal }}</td>
          <!-- F.Y. 2023-24 Data -->
          <td>{{ rowData['Lots 2023-24'] }}</td>
          <td (click)="getDrillDownData(rowData, '5', 'success', rowData['Success Applications 2023-24'], '2023-24')" class="clickable-text">{{ rowData['Success Applications 2023-24'] }}</td>
          <td>{{ rowData['Success Amount 2023-24'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '5', 'success', rowData['Error Applications 2023-24'], '2023-24')" class="clickable-text">{{ rowData['Error Applications 2023-24'] }}</td>
          <td>{{ rowData['Error Amount 2023-24'] | indianDecimal }}</td>
          <!-- F.Y. 2024-25 Data -->
          <td>{{ rowData['Lots 2024-25'] }}</td>
          <td (click)="getDrillDownData(rowData, '5', 'success', rowData['Success Applications 2024-25'], '2024-25')" class="clickable-text">{{ rowData['Success Applications 2024-25'] }}</td>
          <td>{{ rowData['Success Amount 2024-25'] | indianDecimal }}</td>
          <td (click)="getDrillDownData(rowData, '5', 'error', rowData['Error Applications 2024-25'], '2024-25')" class="clickable-text">{{ rowData['Error Applications 2024-25'] }}</td>
          <td>{{ rowData['Error Amount 2024-25'] | indianDecimal }}</td>
        </tr>
      </ng-template>

      <!-- Footer for Grand Totals -->
      <ng-template pTemplate="footer">
        <tr class="grand-total-row">
          <td colspan="2" style="text-align: right; font-weight: bold;">Grand Total:</td>
          <!-- F.Y. - Totals -->
          <td>{{ grandTotals5['Lots -'] }}</td>
          <td>{{ grandTotals5['Success Applications -'] }}</td>
          <td>{{ grandTotals5['Success Amount -'] | indianDecimal }}</td>
          <td>{{ grandTotals5['Error Applications -'] }}</td>
          <td>{{ grandTotals5['Error Amount -'] | indianDecimal }}</td>
          <!-- F.Y. 2022-23 Totals -->
          <td>{{ grandTotals5['Lots 2022-23'] }}</td>
          <td>{{ grandTotals5['Success Applications 2022-23'] }}</td>
          <td>{{ grandTotals5['Success Amount 2022-23'] | indianDecimal }}</td>
          <td>{{ grandTotals5['Error Applications 2022-23'] }}</td>
          <td>{{ grandTotals5['Error Amount 2022-23'] | indianDecimal }}</td>
          <!-- F.Y. 2023-24 Totals -->
          <td>{{ grandTotals5['Lots 2023-24'] }}</td>
          <td>{{ grandTotals5['Success Applications 2023-24'] }}</td>
          <td>{{ grandTotals5['Success Amount 2023-24'] | indianDecimal }}</td>
          <td>{{ grandTotals5['Error Applications 2023-24'] }}</td>
          <td>{{ grandTotals5['Error Amount 2023-24'] | indianDecimal }}</td>
          <!-- F.Y. 2024-25 Totals -->
          <td>{{ grandTotals5['Lots 2024-25'] }}</td>
          <td>{{ grandTotals5['Success Applications 2024-25'] }}</td>
          <td>{{ grandTotals5['Success Amount 2024-25'] | indianDecimal }}</td>
          <td>{{ grandTotals5['Error Applications 2024-25'] }}</td>
          <td>{{ grandTotals5['Error Amount 2024-25'] | indianDecimal }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="summary">
        <div *ngIf="casteWiseDataType5.length > 0" class="caste-count-container">
          <p>Caste wise total lot count</p>
          <ul>
            <li *ngFor="let item of casteWiseDataType5">
              <strong> {{ item.Caste }} - </strong> {{ item.Count }}
            </li>
          </ul>
        </div>
      </ng-template>
    </p-table>

    <!-- Loader for Third Table -->
    <p-progressSpinner *ngIf="loadingTable5" styleClass="custom-spinner"></p-progressSpinner>
  </div>

</div>

<p-dialog header="" [(visible)]="showTable1Lot" [modal]="true" [style]="{width: '100%',height:'100%'}"
    [maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="onCloseDialogT1()">
    <div *ngIf="showSubsidyToFarmer">
      <app-subsidy-to-farmer-cao-pfms-report [lotDetails]="selectedRowVal"></app-subsidy-to-farmer-cao-pfms-report>
      <!-- <app-subsidy-to-farmer-pfms-report [lotDetails]="selectedRowVal"></app-subsidy-to-farmer-pfms-report> -->
    </div>
    <div *ngIf="showSubsidyToVendor">
      <app-subsidy-to-vendor-cao-pfms-report [lotDetails]="selectedRowVal"></app-subsidy-to-vendor-cao-pfms-report>
      <!-- <app-subsidy-to-vendor-pfms-report [lotDetails]="selectedRowVal"></app-subsidy-to-vendor-pfms-report> -->
    </div>
</p-dialog>

<p-dialog header="" [(visible)]="showTable2Lot" [modal]="true" [style]="{width: '100%',height:'100%'}"
    [maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="onCloseDialogT2()">
    <div *ngIf="showTanksS1">
      <!-- <app-tank-stage1-pfms-report [lotDetails]="selectedRowVal"></app-tank-stage1-pfms-report> -->
      <app-tank-stage1-cao-pfms-report [lotDetails]="selectedRowVal"></app-tank-stage1-cao-pfms-report>
    </div>
    <div *ngIf="showTanksS2">
      <app-tank-stage2-cao-pfms-report [lotDetails]="selectedRowVal"></app-tank-stage2-cao-pfms-report>
    </div>
    <div *ngIf="showTanksS3">
      <app-tank-stage3-cao-pfms-report [lotDetails]="selectedRowVal"></app-tank-stage3-cao-pfms-report>
    </div>
</p-dialog>

<!-- <p-dialog header="" [(visible)]="showTable4Lot" [modal]="true" [style]="{width: '100%',height:'100%'}"
    [maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="onCloseDialogT4()">
    <div *ngIf="showRefundToFarmer">
      <app-return-to-farmer-pfms-report [lotDetails]="selectedRowVal"></app-return-to-farmer-pfms-report>
    </div>
    <div *ngIf="showFarmerShareToVendor">
      <app-farmer-share-to-vendor-pfms-report [lotDetails]="selectedRowVal"></app-farmer-share-to-vendor-pfms-report>
    </div>
</p-dialog> -->

<p-dialog header="" [(visible)]="showTable4Lot" [modal]="true" [style]="{width: '100%', height: '100%'}"
[maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="onCloseDialogT4()">

<div *ngIf="showRefundToFarmer">
  <app-return-to-farmer-cao-pfms-report [lotDetails]="selectedRowVal"></app-return-to-farmer-cao-pfms-report>
</div>

<div *ngIf="showFarmerShareToVendor">
  <app-farmer-share-to-vendor-cao-pfms-report [lotDetails]="selectedRowVal"></app-farmer-share-to-vendor-cao-pfms-report>
</div>

</p-dialog>

<p-dialog header="" [(visible)]="showDrillDownReport" [modal]="true" [style]="{width: '100%', height: '100%'}"
    [maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="onCloseDDReport()">
    <app-subsidy-distribution-drill-down-report *ngIf="showDrillDownReport" [drillDownReqDetails]="drillDownReqDetails"></app-subsidy-distribution-drill-down-report>
</p-dialog>


<!-- <div #pondDrillDownData *ngIf="showPondIncompleteDetails">
  <app-pond-incomplete-count-wise-report [finyear]="selectedYearForData"></app-pond-incomplete-count-wise-report>
</div> -->